import { Tab, Tabs } from "react-bootstrap";
import { OperatingRevenueTable } from "./OperatingRevenueTable";
import { ReductionsTable } from "./ReductionsTable";

export const FinancialAnalysisSection = ({
  netOperatingIncome,
  setNetOperatingIncome,
  estimatedAssetValue,
  setEstimatedAssetValue,
}) => {
  return (
    <>
      <Tabs activeKey={"financial-analysis"}>
        <Tab
          eventKey={"financial-analysis"}
          title="Financial Analysis"
          tabClassName="capitalize text-left"
        >
          <OperatingRevenueTable />

          <ReductionsTable
            netOperatingIncome={netOperatingIncome}
            setNetOperatingIncome={setNetOperatingIncome}
            estimatedAssetValue={estimatedAssetValue}
            setEstimatedAssetValue={setEstimatedAssetValue}
          />
        </Tab>
      </Tabs>
    </>
  );
};
